export default __webpack_public_path__ + "static/media/Truck_Reefer_Icon.77f36bb4.svg";